import { useLoggerStreamTranscriptions } from '@app/modules/audit/hooks/useLoggerStreamTranscriptions';
import { Station } from '@app/core/types/stations';
import { isDiarizationSegmentsEnabled } from '@app/modules/logger/screens/stream/diarization/isDiarizationSegmentsEnabled';
import { parseRangeFromTs } from '@mi-front/core';
import { useDebounce } from 'use-debounce';
import { useFocus } from '../../../stores/stream-screen.store';
import TranscriptionsView from './TranscriptionsView';

interface TranscriptionsContainerProps {
  station: Station;
}

/**
 * Transcriptions audit tab: loads hour-bucketed hits for the debounced focus range.
 */
export function TranscriptionsContainer({ station }: TranscriptionsContainerProps) {
  const focus = useFocus();
  const [debouncedFocus] = useDebounce(focus, 300);
  const range = parseRangeFromTs(debouncedFocus);

  const diarization = isDiarizationSegmentsEnabled(station);
  const { data, isLoading } = useLoggerStreamTranscriptions(station, range, diarization);

  return <TranscriptionsView data={data ?? []} loading={isLoading} station={station} />;
}

export default TranscriptionsContainer;
